import { API, encode } from "@lysaab/ui-2";
export var ConfirmStatus;
(function (ConfirmStatus) {
    ConfirmStatus["OK"] = "OK";
    ConfirmStatus["ONFIDO_USER_ERROR"] = "ONFIDO_USER_ERROR";
})(ConfirmStatus || (ConfirmStatus = {}));
export function logSignup(signupId, event) {
    const url = encode `/onfido/onboarding/log?signupId=${signupId}`;
    return API.post(url, {
        event: JSON.stringify(Object.assign(Object.assign({}, event), { signupId }), null, 2),
    });
}
export function logReset(resetId, event) {
    const url = encode `/onfido/authenticationreset/log?authenticationResetId=${resetId}`;
    return API.post(url, {
        event: JSON.stringify(Object.assign(Object.assign({}, event), { resetId }), null, 2),
    });
}
export function sendResumeEmail(signupId, language) {
    const url = "/onfido/onboarding/resume";
    return API.post(url, { signupId, language });
}
export function sendResumeEmailId(signupId, language) {
    const url = "/onfido/onboarding/resume-id";
    return API.post(url, { signupId, language });
}
export function sendResumeEmailPoa(signupId, language) {
    const url = "/onfido/onboarding/resume-poa";
    return API.post(url, { signupId, language });
}
export function identityEnhancedCheck(signupId) {
    const url = encode `/onfido/onboarding/poa/identityEnhanced/confirm?signupId=${signupId}`;
    return API.post(url);
}
export function getOnfidoStatus(signupId) {
    const url = encode `/onfido/onboarding/status?signupId=${signupId}`;
    return API.get(url, true);
}
